const YMM_STORAGE_KEY = 'ymm_selection';

export type YmmStoredSelection = {
  year: string;
  make: string;
  model: string;
};

/**
 * Reads YMM from localStorage. Returns only when all three (year, make, model) are present and non-empty.
 */
export function getYmmFromStorage(): YmmStoredSelection | null {
  try {
    const raw = window.localStorage.getItem(YMM_STORAGE_KEY);

    if (!raw) return null;

    const parsed = JSON.parse(raw);

    if (
      parsed &&
      'year' in parsed &&
      'make' in parsed &&
      'model' in parsed
    ) {
      const sel = parsed as YmmStoredSelection;
      if (sel.year && sel.make && sel.model) return sel;
    }
    return null;
  } catch {
    return null;
  }
}

export function setYmmToStorage(selection: YmmStoredSelection): void {

  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(YMM_STORAGE_KEY, JSON.stringify(selection));
  } catch {
    // ignore quota or other errors
  }
}

export function clearYmmStorage(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(YMM_STORAGE_KEY);
  } catch {
    // ignore
  }
}
